<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs />
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>考级资源管理</span>
            <!-- <router-link :to="{ name: 'internationalWatersExportList' }">
              分配记录导出
            </router-link> -->
          </div>

          <div class="input-area none-month" @keyup.enter="inputAreaKeyup">
            <!-- 创建日期 -->
            <div class="box-content">
              <label class="form-tit">创建日期</label>
              <el-date-picker
                clearable
                v-model="searchData.create_time"
                type="daterange"
                unlink-panels
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                class="jm-input280" />
            </div>

            <!-- 创建类型 -->
            <div class="box-content">
              <label class="form-tit">创建类型</label>
              <jm-dict-select
                v-model="searchData.create_type"
                clearable
                class="jm-input135"
                dict="dataset.training.createType" />
            </div>

            <!-- 客户状态 -->
            <div class="box-content">
              <label class="form-tit">客户状态</label>
              <jm-dict-select
                clearable type="dataset" dict-type="training"
                name="trainingLevelType" v-model="searchData.customer_status" />
            </div>

            <!-- 渠道来源 -->
            <div class="box-content box-content-double">
              <label class="form-tit">渠道来源</label>
              <jm-channel v-model="searchData.channels" clearable filterable />
            </div>

            <!-- 活动编码 -->
            <div class="box-content">
              <label class="form-tit">活动编码</label>
              <el-input v-model="searchData.activity_code" clearable class="jm-input175" />
            </div>

            <!-- 意向分级 -->
            <div class="box-content">
              <label class="form-tit">意向分级</label>
              <jm-dict-select
                v-model="searchData.customer_classify"
                clearable
                class="jm-input135"
                type="dataset"
                dict-type="training"
                name="trainingLvType" />
            </div>
            <div class="box-content">
              <label class="form-tit">回访次数</label>
              <el-input v-model="searchData.visit_count1" class="jm-input90" />
              <em>至</em>
              <el-input v-model="searchData.visit_count2" class="jm-input90" />
            </div>
            <div class="jm-primary">
              <el-button type="primary" :disabled="!canSearch" @click="() => this.refresh = true">开始查询</el-button>
              <el-button type="primary" :disabled="!canSearch" @click="initSearchData()">清空条件</el-button>
              <el-button type="success" :disabled="!canSearch" @click="() => { distributionDialogVisible = true; initSayerList() }">进入分配</el-button>
            </div>
          </div>
          <jm-tableList
            ref="stable"
            url="/training/kaoji_management/pagetable"
            :search-data="searchData"
            :refresh.sync="refresh"
            row-key="id">
            <el-table-column
              slot="username"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="id">
              <template slot-scope="scope">
                <el-tag v-for="link in scope.row.link_others" :key="link.id">{{ getSiteTagByType(link.sync_type) }}</el-tag>
                {{ scope.row.username }} {{ scope.row.nickname ? `/ ${scope.row.nickname}` : '' }}
              </template>
            </el-table-column>
            <el-table-column
              slot="visit_log"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="id">
              <template slot-scope="scope">
                <div class="box">
                  <div class="top">
                    <el-tooltip placement="top-start">
                      <div slot="content">
                        <div style="max-width:400px" v-text="scope.row.visit_log"></div>
                      </div>
                      <p>{{ scope.row.visit_log|filterFun }}</p>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              slot="lastColumn"
              label="操作"
              :min-width="100"
              class-name="scope-button-list">
              <template slot-scope="scope">
                <el-row>
                  <router-link target="_blank" :to="{ name: 'resourceEdit', params: { id: scope.row.id } }">
                    <el-button size="mini" type="primary">查看</el-button>
                  </router-link>
                </el-row>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
    <el-dialog
      title="资源分配"
      :visible.sync="distributionDialogVisible"
      width="60%"
      top="40px"
      :close-on-click-modal="false"
      :fullscreen="false"
      center>
      <!-- <el-alert title="xxxxx"></el-alert> -->
      <!--数据结果-->
      <div class="serch-wapper" v-loading="loading" style="display:block;height:550px;">
        <div class="water-table">
          <div class="water-head">
            <el-col class="water-name-common" :span="8">咨询老师</el-col>
            <el-col class="water-name" :span="8">
              待分配资源
              <!-- <br />
              {{ '剩余' + 8888 }} -->
            </el-col>
            <!-- <el-col
              class="water-name"
              :span="3"
              v-for="(item,index) in tableHeadData"
              :key="index">
              {{ item.name }}
              <br />
              {{ '剩余' + item.value }}
            </el-col> -->
            <el-col class="water-name-common" :span="8">操作</el-col>
          </div>
          <div class="water-content-list">
            <el-scrollbar style="height:500px;">
              <el-col
                class="water-tr"
                :span="24"
                v-for="(item,index) in tableData"
                :key="index">
                <el-form status-icon ref="item" style="margin:0;height:100%;">
                  <el-col :span="8" class="water-td">
                    {{ item.name }}
                    <!--<br /> &nbsp;
                    <span class="water-all" title="总资源数">{{ item.total }}</span>
                    （<span class="water-mix" style="color:green" title="公海资源数">{{ item.seaNum }}</span> +
                    <span class="water-mix" style="color:red" title="一手资源数">{{ item.studentNum }}</span>） -->
                  </el-col>
                  <el-col :span="8" class="water-td">
                    <el-form-item prop="inputVal" style="margin-bottom: 0;height:100%">
                      <el-input-number v-model="item.userData.distribute" autocomplete="off" :controls="false" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <div class="btn-group">
                      <el-button type="primary" size="mini" @click="distribute(index)">分配</el-button>
                      <el-button type="warning" size="mini" @click="clearInput(index)">清空</el-button>
                    </div>
                  </el-col>
                </el-form>
              </el-col>
            </el-scrollbar>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="distributeAll" :disabled="loading">全部分配</el-button>
        <el-button type="warning" @click="clearAllInput" :disabled="loading">清空输入</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import '@/assets/css/index.css';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { deepMerge, filterVisible, getSiteTagByType } from '@/utils/utils';
import { targetLan } from '@/dataset/training';
import {
  jmAreaselect,
  jmChannel,
  jmDictSelect,
  jmEducationSelect,
  jmExamjpSelect,
  jmLessonSelect
} from '@/components/tool';
import student from '@/pages/student/student';

const defaultSearchData = {
  create_time: '',
  create_type: '',
  channels: {
    custom_from: '',
    custom_from_sub: '',
    custom_from_thrid: '',
    custom_from_fourth: '',
    custom_from_fifth: ''
  },
  activity_code: '',
  customer_status: '',
  customer_classify: ''
};
export default {
  name: 'ResourceManager',
  mixins: [student],
  data() {
    return {
      trainingTargetLan: targetLan,
      refresh: false,
      exporting: false,
      searchData: {},

      /* 分配相关 */
      distributionDialogVisible: false,
      tableHeadData: null,
      tableData: [],
      loading: true,
      localData: null
    };
  },
  components: {
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmAreaselect,
    jmChannel,
    jmLessonSelect,
    jmEducationSelect,
    jmDictSelect,
    jmExamjpSelect
  },
  filters: {
    filterFun: function (value) {
      if (value && value.length > 10) {
        value = `${value.substring(0, 10)}...`;
      }
      return value;
    },
  },
  methods: {
    filterVisible,
    getSiteTagByType,
    initSearchData() {
      this.searchData = deepMerge({}, defaultSearchData);
    },

    /**
     * 关闭分配窗
     */
    handleDialogClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    /**
     * 根据国家过来老师列表
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param {Object} teachers 老师数据
     * @param {Array} teacherIds 允许的老师ID
     * @return {Object}
     */
    filterTeachers(teachers, teacherIds = []) {
      if (!teachers) {
        return teachers;
      }
      let currentTeachers = { ...teachers };
      Object.entries(currentTeachers).forEach(([char, teacher]) => {
        teacher = teacher.filter((t) => {
          if (t.userid === -1) {
            return true;
          }
          if (teacherIds.length > 0 && teacherIds.indexOf(t.userid) >= 0) {
            return true;
          }
          return (this.userInfo.countries.indexOf(t.country) >= 0);
        });
        currentTeachers[char] = teacher;
        if (teacher.length === 0) {
          delete currentTeachers[char];
        }
      });
      return currentTeachers;
    },


    /**
     * 更新数据
     */
    initSayerList() {
      this.loading = true;
      Promise.all([
        this.$http._post({
          url: '/training/kaoji_management/getSayerList',
          data: { searchData: this.searchData }
        }),
        // this.$http._post({
        //   url: '/training/kaoji_management/getCount',
        //   data: { searchData: this.searchData }
        // })
      ]).then((result) => {
        const [sayerData] = result;
        console.info(sayerData);
        this.searchSayer(sayerData.data);
        // this.initTableHeader(levelNumber);
      });

      // this.$http._post({
      //   url: '/training/kaoji_management/getSayerList',
      //   data: { searchData: this.searchData }
      // }).then(({ data: sayerData }) => {
      //   console.log(sayerData);
      //   this.searchSayer(sayerData);
      // });
    },
    /**
     * 根据国家查询顾问列表
     */
    searchSayer(data) {
      this.tableData = Object.values(data);
      this.tableData.forEach((item) => {
        item.userData = {
          crmsayer: item.userid,
          distribute: 0,
        };
      });
      this.loading = false;
    },
    // /**
    //  * 查询指定国家公海各个资源级别的数量
    //  */
    // initTableHeader(data) {
    //   this.tableHeadData = [
    //     { name: '一级资源', value: data.levelOne },
    //     { name: '二级资源', value: data.levelTwo },
    //     { name: '三级资源', value: data.levelThree },
    //     { name: '四级资源', value: data.levelFour },
    //     { name: '五级资源', value: data.levelFive }
    //   ];
    //   this.loading = false;
    // },
    /**
     * 按人清空
     */
    clearInput(index) {
      this.tableData[index].userData.distribute = 0;
    },
    clearAllInput() {
      this.tableData.forEach((item) => {
        item.userData.distribute = 0;
      });
    },
    /**
     * 单独分配
     */
    distribute(index) {
      let that = this;
      this.$confirm('确认分配后，将无法撤回，是否确认？', '确认分配', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ajaxData = [that.tableData[index].userData];
          // 请求
          this.assignmentAjax(ajaxData)
            .then(() => {
              this.$message({
                type: 'success',
                message: '分配成功!'
              });
              this.clearInput(index);
            })
            .catch((res) => {
              this.$message({
                type: 'error',
                message: res
              });
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消分配'
          });
        });
    },
    /**
     * 全部分配
     */
    distributeAll() {
      let that = this;
      this.$confirm(
        '确认后，对填写分配数的所有顾问进行公海资源分配，无法撤回，是否确认？',
        '确认全部分配', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          const tableList = [];
          that.tableData.forEach((item) => {
            if (item.userData.distribute !== 0) {
              tableList.push(item.userData);
            }
          });

          this.assignmentAjax(tableList)
            .then(() => {
              this.$message({
                type: 'success',
                message: '分配成功!'
              });
              this.clearAllInput();
            })
            .catch((err) => {
              // 可能后台 或者 Error对象
              this.$message({
                type: 'error',
                message: (err instanceof Error) ? err : err.data.data
              });
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消分配'
          });
        });
    },
    /**
     * 分配资源请求
     */
    async assignmentAjax(assignmentData) {
      // let distribute = 0;
      // assignmentData.forEach((item) => {
      //   distribute += item.distribute;
      // });

      // if (this.tableHeadData[0].value < levelOneVal) {
      //   return Promise.reject(new Error('一级资源不足无法分配'));
      // } else if (this.tableHeadData[1].value < levelTwoVal) {
      //   return Promise.reject(new Error('二级资源不足无法分配'));
      // } else if (this.tableHeadData[2].value < levelThreeVal) {
      //   return Promise.reject(new Error('三级资源不足无法分配'));
      // } else if (this.tableHeadData[3].value < levelFourVal) {
      //   return Promise.reject(new Error('四级资源不足无法分配'));
      // } else if (this.tableHeadData[4].value < levelFiveVal) {
      //   return Promise.reject(new Error('五级资源不足无法分配'));
      // }
      let ajaxData = {
        searchData: this.searchData,
        configData: assignmentData
      };
      // console.log(ajaxData);
      // return;// 调试
      this.loading = true;

      return new Promise((resolve, reject) => {
        this.$http
          ._post({
            url: '/training/kaoji_management/distributionSource',
            data: ajaxData
          })
          .then((res) => {
            // console.log(res);
            this.initSayerList();
            return resolve(res);
          })
          .catch((res) => {
            this.loading = false;
            return reject(res);
          });
      });
    },
  },
  created() {
    this.getDatasource();
    this.initSearchData();
    this.initSayerList();
  },
  computed: {
    trainingTeachers() {
      if (this.$hasPermission(1)) {
        return this.ds.training_teacher;
      }
      return this.filterTeachers(this.ds.training_teacher);
    },
    createPersonZZ() {
      if (this.ds.create_person && this.ds.create_person.ZZ) {
        return this.ds.create_person.ZZ.filter(item => item.userid < 0);
      }
      return [];
    },
  },
  watch: {
    canSearch(value) {
      if (value === false) {
        this.refresh = true;
      }
    }
  }
};
</script>

<style>
.tableList a.red {
    color: red;
}
.name-tip-l {
    display: inline-block;
    width: 5px;
    height: 15px;
    background-color: #3368fa;
    margin-top: 5px;
    border-radius: 2px;
    margin-right: 5px;
}
.scope-button-list .cell {
    display: flex;
    justify-content: space-around;
}
.box-content-double {
    width: 66.6% !important;
}
.box-content-double .el-checkbox__label {
    color: #f60;
}
.button-search {
    margin-right: 10px;
    display: inline-block;
    height: 100%;
}
.button-search:last-of-type {
    margin-left: 3px;
}
</style>
<style scoped>
.basic-title em.normal {
    border-bottom: none;
}
.basic-title em a {
    color:#333;
}
.notice-big-wapper {
    background: #fff;
}
.notice-wapper,
.rank-wapper {
    padding: 16px;
}
.notice-right {
    width: 400px;
    border: 1px solid #409eff;
    padding-bottom: 10px;
}
.notice-right>div {
    padding: 0 10px;
}
.notice-right h2 {
    text-align: center;
    color: #409eff;
    margin: 10px 0;
}
.notice-right p {
    line-height: 26px;
    font-size: 12px;
}
.notice-right span {
    color: red;
}
.notice-right i {
    font-weight: 600;
}
.notice-right em {
    color: #666;
}
.notice-wapper::after {
    display: block;
    content: '';
    clear: both;
    opacity: 0;
}
.get-group {
    margin-bottom: 78px;
}
.get-group span {
    margin-left: 16px;
}
.get-group span em {
    color: #409eff;
}

.rank-num>div {
    margin-right: 30px;
    text-align: center;
    color: #409eff;
}
.rank-num>div p:nth-of-type(1) {
    font-size: 18px;
    margin-bottom: 6px;
}
.rank-num>div p:nth-of-type(2) {
    font-size: 12px;
}
.btn-sendim.active {
    cursor: not-allowed;
}
.btn-sendim.active button {
    background: #999;
    border-color: #999;
    cursor: not-allowed;
}
.box-radio-checkbox .el-radio-group {
    display: inline-block;
}
.box-radio-checkbox .el-checkbox-group {
    display: inline-block;
}
.serch-wapper::after {
    display: block;
    content: '';
    clear: both;
    opacity: 0;
}
</style>
<style lang="less" scoped>
.water-table {
    width: 100%;
    height: auto;
    margin-bottom: 20px;

    /* margin-top: 20px; */
    .water-head-fix {
        position: fixed;
        top: 80px;
        /* padding: 10px 20px; */
        box-shadow: 5px 5px 5px #ccc;
        width: 100%;
        z-index: 99;
    }

    .water-head {
        width: 100%;
        height: 60px;
        line-height: 60px;
        background: #01142d;

        .water-name-common, .water-name {
            border-right: 1px solid #fff;
            color: #fff;
            font-size: 14px;
            text-align: center;
        }

        /*.water-name {
            line-height: 30px;
        }*/
    }

    .water-content-list {
        width: 100%;
        height: 50px;

        .water-tr {
            width: 100%;
            height: 100%;
            border: 1px solid #ccc;
            border-top: 0px;
            border-right: 0px;

            .water-td {
                height: 100%;
                border-right: 1px solid #ccc;
                text-align: center;
                line-height: 50px;

                .water-all {
                    color: #333;
                }
                .el-input {
                    width: 100%;
                    height: 100%;
                    line-height: 50px;

                    .el-input__inner {
                        text-align: center;
                        width: 100%;
                        height: 48px;
                        line-height: 50px;
                        border-color: #fff;
                    }
                }
                .el-form-item.is-error .el-input__inner {
                    border-color: #f56c6c;
                }
                .el-input__inner:focus {
                    border-color: #fff;
                }
            }
            .btn-group {
                width: 100%;
                height: 100%;
                margin-top: 10px;
                text-align: center;
            }
        }
    }
}
</style>
<style lang="less">
.water-content-list {
    .el-input__inner {
        text-align: center;
        width: 100%;
        height: 48px;
        line-height: 50px;
        border-color: #fff;
    }
    .el-form-item.is-error .el-input__inner {
        border-color: #f56c6c;
    }
    .el-input__inner:focus {
        border-color: #fff;
    }
    .el-scrollbar__wrap {
        overflow-x: hidden!important;
    }
}

</style>
